import { UPDATE_STATUS, EDIT_SEARCH } from "./actionTypes";

export const updateStatus = (status) => {
  return {
    type: UPDATE_STATUS,
    payload: status,
  };
};

export const editSearch = (text) => {
  return {
    type: EDIT_SEARCH,
    payload: text,
  };
};
